import React from "react";

interface SkeletonCardProps {
  count?: number;
}

const SkeletonCard: React.FC<SkeletonCardProps> = ({ count = 8 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-card">
          <div className="skeleton-dot skeleton-line" />
          <div className="skeleton-info">
            <div className="skeleton-addr skeleton-line" />
            <div className="skeleton-meta skeleton-line" />
          </div>
          <div className="skeleton-fin skeleton-line" />
        </div>
      ))}
    </>
  );
};

export default SkeletonCard;
